import React, { useEffect, useState, lazy } from 'react';
import { CTAButton } from './CTAButton';
import { Check, ShieldCheck, Truck, Clock, Star, Gem, Gift, BookOpen } from 'lucide-react';
import { cn } from '../../lib/utils';
export function BundleOfferSection() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 47,
    seconds: 33
  });
  const [selectedBundle, setSelectedBundle] = useState(1); // 0-indexed, 1 = Most Popular (3-pack)
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          ...prev,
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const bundles = [{
    title: 'Starter Trial',
    qty: '1 Tube',
    price: '29.95',
    original: null,
    save: null,
    badge: null,
    cta: 'Order Now',
    image: 'https://cdn.magicpatterns.com/uploads/4gs7hk5gbp3ffeCKHXQwfY/imgi_2_1758983694-4_(54).png',
    imageAlt: 'Dentafix™ single tube'
  }, {
    title: 'Most Popular',
    qty: '3 Tubes',
    sub: '3 Months Supply',
    price: '59.95',
    original: '89.85',
    save: '~35%',
    badge: 'MOST POPULAR',
    cta: 'Claim My 3-Pack',
    highlight: true,
    image: 'https://cdn.magicpatterns.com/uploads/4apRnAXMGamoboxH7gJPVC/imgi_26_1758983830-6_(68).png',
    imageAlt: 'Dentafix™ 3-pack bundle'
  }, {
    title: 'Best Value',
    qty: '6 Tubes',
    sub: 'Never Run Out',
    price: '89.95',
    original: '179.70',
    save: '~50%',
    badge: 'BEST VALUE',
    cta: 'Claim Best Value',
    premium: true,
    image: 'https://cdn.magicpatterns.com/uploads/4199QpnCDbJTXbUeMCBbHg/imgi_27_1763410434-Copy_of_Copy_of_Copy_of_Copy_of_Copy_of_DEMOSTRATION_(1024_x_1536_px)_(26).png',
    imageAlt: 'Dentafix™ 6-pack bundle'
  }];
  return <section id="offers" className="py-16 md:py-24 bg-gradient-to-b from-rose-50 to-white" data-id="element-23">
      <div className="container mx-auto px-4 md:px-6" data-id="element-24">
        {/* Product lifestyle banner */}
        <div className="mb-12 relative rounded-2xl overflow-hidden shadow-xl" data-id="element-25">
          <img src="https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=1200&q=80" alt="Premium healthcare product" className="w-full h-48 md:h-64 object-cover" loading="lazy" data-id="element-26" />
          <div className="absolute inset-0 bg-gradient-to-r from-red-600/80 via-red-600/60 to-transparent flex items-center" data-id="element-27">
            <div className="p-8 md:p-12" data-id="element-28">
              <p className="text-white/90 text-sm font-bold uppercase tracking-wider mb-2" data-id="element-29">
                Limited Time Offer
              </p>
              <p className="text-white text-2xl md:text-4xl font-serif font-bold mb-2" data-id="element-30">
                Save Up to 50%
              </p>
              <p className="text-white/80 text-lg" data-id="element-31">
                Free worldwide shipping on every bundle
              </p>
            </div>
          </div>
        </div>

        {/* Header & Timer */}
        <div className="text-center mb-12" data-id="element-32">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4 font-serif" data-id="element-33">
            Choose Your Comfort Bundle
          </h2>
          <p className="text-xl text-gray-600 mb-4" data-id="element-34">
            Free Worldwide Shipping on Every Order
          </p>

          {/* Social proof line above bundles */}
          <p className="text-lg text-gray-700 max-w-2xl mx-auto mb-8 bg-amber-50 border border-amber-200 rounded-xl px-6 py-3" data-id="element-35">
            <Star className="w-5 h-5 inline text-amber-500 fill-amber-500 -mt-0.5 mr-1" data-id="element-36" />
            Most customers choose the 3-pack because denture confidence isn't a
            one-day fix — it's daily peace of mind.
          </p>

          <div className="inline-flex items-center gap-4 bg-red-50 border border-red-100 px-6 py-3 rounded-full shadow-sm" data-id="element-37">
            <Clock className="w-5 h-5 text-red-600 animate-pulse" data-id="element-38" />
            <span className="text-red-800 font-semibold" data-id="element-39">
              Today's Special Promotion Ends In:
            </span>
            <span className="font-mono font-bold text-red-600 text-xl" data-id="element-40">
              {String(timeLeft.hours).padStart(2, '0')}:
              {String(timeLeft.minutes).padStart(2, '0')}:
              {String(timeLeft.seconds).padStart(2, '0')}
            </span>
          </div>
        </div>

        {/* Bundles Grid — 3 cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-end max-w-4xl mx-auto pt-6" data-id="element-41">
          {bundles.map((bundle, index) => <div key={index} onClick={() => setSelectedBundle(index)} className={cn('relative rounded-2xl cursor-pointer transition-all duration-300 flex flex-col h-full', selectedBundle === index ? 'bg-white ring-4 ring-red-500 shadow-2xl scale-105 z-10' : 'bg-white border border-gray-200 shadow-lg hover:shadow-xl hover:border-red-200')} data-id="element-42">
              {/* Badges */}
              {bundle.badge && <div className={cn('absolute -top-4 left-1/2 -translate-x-1/2 px-4 py-1 rounded-full text-xs font-bold tracking-wider shadow-sm uppercase whitespace-nowrap z-20', bundle.highlight ? 'bg-amber-400 text-white' : 'bg-blue-600 text-white')} data-id="element-43">
                  {bundle.premium && <Gem className="w-3 h-3 inline mr-1" data-id="element-44" />}
                  {bundle.highlight && <Star className="w-3 h-3 inline mr-1 fill-white" data-id="element-45" />}
                  {bundle.badge}
                </div>}

              {/* Product Image */}
              <div className="bg-gradient-to-b from-rose-50 to-white p-4 flex items-center justify-center rounded-t-2xl overflow-hidden" data-id="element-46">
                <img src={bundle.image} alt={bundle.imageAlt} className="h-40 md:h-48 object-contain drop-shadow-md hover:scale-105 transition-transform duration-300" data-id="element-47" />
              </div>

              <div className="p-6 flex flex-col flex-1" data-id="element-48">
                <div className="text-center mb-6" data-id="element-49">
                  <h3 className="text-gray-500 font-medium text-sm uppercase tracking-wide mb-1" data-id="element-50">
                    {bundle.title}
                  </h3>
                  <p className="text-2xl font-bold text-gray-900" data-id="element-51">
                    {bundle.qty}
                  </p>
                  {bundle.sub && <p className="text-green-600 text-sm font-bold" data-id="element-52">
                      {bundle.sub}
                    </p>}
                </div>

                <div className="text-center mb-6" data-id="element-53">
                  {bundle.original && <p className="text-gray-400 line-through text-sm" data-id="element-54">
                      Was ${bundle.original}
                    </p>}
                  <div className="flex items-center justify-center gap-1" data-id="element-55">
                    <span className="text-lg font-bold text-gray-900" data-id="element-56">$</span>
                    <span className="text-4xl font-bold text-gray-900" data-id="element-57">
                      {bundle.price}
                    </span>
                  </div>
                  {bundle.save && <div className="mt-2 inline-block bg-green-100 text-green-700 text-xs font-bold px-2 py-1 rounded" data-id="element-58">
                      Save {bundle.save}
                    </div>}
                </div>

                <ul className="space-y-3 mb-8 flex-1" data-id="element-59">
                  <li className="flex items-center gap-2 text-sm text-gray-600" data-id="element-60">
                    <Check className="w-4 h-4 text-green-500 shrink-0" data-id="element-61" />
                    <span data-id="element-62">Free Worldwide Shipping</span>
                  </li>
                  <li className="flex items-center gap-2 text-sm text-gray-600" data-id="element-63">
                    <Check className="w-4 h-4 text-green-500 shrink-0" data-id="element-64" />
                    <span data-id="element-65">90-Day Smile Guarantee</span>
                  </li>
                  {index >= 1 && <li className="flex items-center gap-2 text-sm text-gray-600" data-id="element-66">
                      <Check className="w-4 h-4 text-green-500 shrink-0" data-id="element-67" />
                      <span data-id="element-68">Priority Processing</span>
                    </li>}
                </ul>

                <CTAButton text={bundle.cta} className="w-full text-base py-3" size="lg" pulse={selectedBundle === index} data-id="element-69" />
              </div>
            </div>)}
        </div>

        {/* Bonus Stack */}
        <div className="max-w-3xl mx-auto mt-10 bg-white border-2 border-dashed border-amber-300 rounded-2xl p-6 md:p-8" data-id="element-70">
          <p className="text-center text-sm font-bold text-amber-700 uppercase tracking-wider mb-4" data-id="element-71">
            Every Order Includes
          </p>
          <div className="flex flex-col md:flex-row justify-center gap-4 md:gap-8" data-id="element-72">
            <div className="flex items-center gap-3" data-id="element-73">
              <div className="bg-amber-100 p-2 rounded-full shrink-0" data-id="element-74">
                <BookOpen className="w-5 h-5 text-amber-600" data-id="element-75" />
              </div>
              <div data-id="element-76">
                <p className="font-bold text-gray-900 text-sm" data-id="element-77">
                  🎁 FREE Denture Confidence Guide
                </p>
                <p className="text-xs text-gray-500" data-id="element-78">$29 Value — Yours Free</p>
              </div>
            </div>
            <div className="flex items-center gap-3" data-id="element-79">
              <div className="bg-blue-100 p-2 rounded-full shrink-0" data-id="element-80">
                <Truck className="w-5 h-5 text-blue-600" data-id="element-81" />
              </div>
              <div data-id="element-82">
                <p className="font-bold text-gray-900 text-sm" data-id="element-83">
                  🚚 Free Worldwide Shipping
                </p>
                <p className="text-xs text-gray-500" data-id="element-84">Delivered to your door</p>
              </div>
            </div>
            <div className="flex items-center gap-3" data-id="element-85">
              <div className="bg-green-100 p-2 rounded-full shrink-0" data-id="element-86">
                <ShieldCheck className="w-5 h-5 text-green-600" data-id="element-87" />
              </div>
              <div data-id="element-88">
                <p className="font-bold text-gray-900 text-sm" data-id="element-89">
                  🛡️ 90-Day Smile Guarantee
                </p>
                <p className="text-xs text-gray-500" data-id="element-90">
                  Full refund, no questions
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Trust Footer */}
        <div className="mt-10 flex flex-wrap justify-center gap-6 md:gap-12 text-gray-500 text-sm font-medium" data-id="element-91">
          <div className="flex items-center gap-2" data-id="element-92">
            <ShieldCheck className="w-5 h-5 text-blue-500" data-id="element-93" />
            <span data-id="element-94">Secure Checkout</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-95">
            <Truck className="w-5 h-5 text-blue-500" data-id="element-96" />
            <span data-id="element-97">Free Shipping</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-98">
            <Check className="w-5 h-5 text-blue-500" data-id="element-99" />
            <span data-id="element-100">90-Day Guarantee</span>
          </div>
        </div>
      </div>
    </section>;
}